<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";

export default {
  name: "MesAdressesSupprimer",
  components: { Popin, Icon, Button, Titre },
  props: {},
  emits: ["confirm"],
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    confirm() {
      this.$refs.popin.hide();
      this.$emit("confirm");
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Supprimer l'adresse de livraison"
  >
    <div class="u-text-center">
      <Icon
        name="alert-circle"
        variant="primary"
        size="lg"
        class="u-mb-xs"
      />
      <Titre
        tag="h1"
        variant="primary"
        size="md"
        class="u-mb-md"
      >
        Supprimer l'adresse de livraison
      </Titre>
      <p class="u-mb-md">
        Êtes-vous sûr(e) de vouloir supprimer cette adresse de vos adresses de livraison ?
      </p>
      <Button
        variant="primary"
        radius="full"
        size="md"
        @click="confirm()"
      >
        Oui je supprime
      </Button>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
